import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, Box, Button } from '@mui/material';

export default function ErrorNotice({
	message,
	onRetry,
	onClose,
}: {
	message: string;
	onRetry?: () => void;
	onClose?: () => void;
}) {
	const { t } = useTranslation();
	return (
		<Alert
			severity="error"
			onClose={onClose}
			sx={{
				minWidth: 0,
				'& .MuiAlert-message': { minWidth: 0, width: '100%', overflowWrap: 'anywhere' },
				'& .MuiAlert-action': { mr: 0, pl: 1, flexShrink: 0 },
			}}
		>
			{message}
			{onRetry && (
				<Box mt={1}>
					<Button size="small" onClick={onRetry}>
						{t('academyReworkings.retry')}
					</Button>
				</Box>
			)}
		</Alert>
	);
}
